<template>
    <div></div>
</template>

<script>
    import { mapMutations, mapActions } from 'vuex'
    export default {
        data () {
            return {}
        },
        beforeCreate () {
            /*this.$message({
                showClose: true,
                message: '请先登录后再操作',
                type: 'warning'
            });*/
            this.$router.push({name: 'index'});
        },
        created () {
            this.logoutUser();
            this.openLogin();
        },
        methods: {
            ...mapActions(['logoutUser']),
            ...mapMutations({
                openLogin: 'setLoginStepLogin'
            }),
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// app/components/Relogin.vue